// Lightweight imperative toast. Deliberately not a React component — it is
// called from react-query onSuccess/onError handlers, outside any render.
const showToast = (message, status) => {
  const toast = document.createElement("div");
  // textContent, not innerHTML: messages include server-supplied error strings.
  toast.textContent = message;
  toast.setAttribute("role", "status");
  toast.className = `fixed bottom-6 right-6 z-50 max-w-sm rounded-md px-5 py-3.5 text-sm font-medium text-white shadow-card-hover transition-opacity duration-300 ${
    status === "success" ? "bg-success" : "bg-danger"
  }`;
  document.body.appendChild(toast);

  setTimeout(() => {
    toast.style.opacity = 0;
    setTimeout(() => toast.remove(), 300);
  }, 3000);
};

export default showToast;
